import { useTranslation } from 'react-i18next';

import { FormTextField } from '~/components/atoms/form-fields/FormTextField';

export const Url = () => {
  const { t } = useTranslation();

  return <FormTextField name="location.url" fullWidth label={t('template5:url')} inputProps={{ maxLength: 500 }} />;
};
